import { MessageCircleOff, ArrowLeft, Plus } from 'lucide-react';

export default function ChatNotFound({ isDarkMode, onStartNewChat, onGoBack }) {
  return (
    <div className="flex items-center justify-center w-full min-h-[70vh] px-4">
      <div
        className={`w-full max-w-md rounded-2xl border p-8 text-center shadow-sm ${
          isDarkMode
            ? 'bg-gray-900 border-gray-700 text-white'
            : 'bg-white border-gray-200 text-gray-900'
        }`}
      >
        <div
          className={`mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full ${
            isDarkMode ? 'bg-gray-800 text-brand' : 'bg-brandLighter text-brand'
          }`}
        >
          <MessageCircleOff size={28} />
        </div>

        <h2 className="mb-2 text-2xl font-bold">Chat not found</h2>

        <p
          className={`mb-6 text-sm leading-6 ${
            isDarkMode ? 'text-gray-300' : 'text-gray-500'
          }`}
        >
          This chat may have been deleted, moved, or you may not have permission
          to access it.
        </p>

        <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
          <button
            onClick={onStartNewChat}
            className="inline-flex items-center justify-center gap-2 rounded-lg bg-gradient-to-r from-brandDark to-brand px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:opacity-90"
          >
            <Plus size={16} />
            Start new chat
          </button>

          <button
            onClick={onGoBack}
            className={`inline-flex items-center justify-center gap-2 rounded-lg border px-4 py-2.5 text-sm font-semibold transition ${
              isDarkMode
                ? 'border-gray-700 text-gray-200 hover:bg-gray-800'
                : 'border-gray-300 text-gray-700 hover:bg-gray-100'
            }`}
          >
            <ArrowLeft size={16} />
            Go back
          </button>
        </div>
      </div>
    </div>
  );
}
